import { ColorStatusType } from "@/constants/colors.constants";
import { ChipStyle } from "../common.model";
import { BusinessType } from "@/api/constants/enums";

export interface CustomerAccountIndividualSummaryDto {
	title?: string;
	firstName?: string;
	lastName?: string;
	birthDate?: string;
	identification?: CustomerIdentificationDto;
}

export interface CustomerAccountOrganizationSummaryDto {
	legalName?: string;
	tradingName: string;
	identification: CustomerIdentificationDto;
}

export interface CustomerAccountSummaryDto {
	id: string;
	bssUrl?: string;
	state: AccountState;
	type: CustomerType;
	businessType?: BusinessType;
	owner?: CustomerAccountIndividualSummaryDto | CustomerAccountOrganizationSummaryDto;
}

export interface CustomerBalancesAndDebtDto {
	debt: boolean;
}

export interface DashboardCustomer {
	customerId: string;
	customerType?: CustomerType;
	state: AccountState;
	firstName?: string;
	lastName?: string;
	legalName?: string;
	tradingName?: string;
	identification?: CustomerIdentificationDto;
	mobileNumber?: string;
	voipNumber?: string;
}

export interface CustomerIdentificationDto {
	type: string;
	number: string;
	country: string;
}

export interface SearchCustomerFilters {
	firstName: string;
	lastName: string;
	legalName: string;
	tradingName: string;
	identificationNumber: string;
	mobileNumber: string;
	voipNumber: string;
	customerId: string;
	email: string;
	limit?: number;
	page?: number;
}

export enum CustomerType {
	BUSINESS = "BUSINESS",
	RESIDENTIAL = "RESIDENTIAL"
}

enum CustomerStates {
	NEW = "New",
	PENDING_ACTIVE = "PendingActive",
	ACTIVE = "Active",
	PENDING_DISCONNECT = "PendingDisconnect",
	DISCONNECTED = "Disconnected",
	CLOSED = "Closed"
}

enum CustomerDocumentStates {
	VALIDATED = "Validated"
}

export const CustomerStateConfig: Record<CustomerStates, ChipStyle> = {
	[CustomerStates.NEW]: {
		color: ColorStatusType.GREY,
		background: ColorStatusType.GREY_LIGHT
	},
	[CustomerStates.PENDING_ACTIVE]: {
		color: ColorStatusType.GREY,
		background: ColorStatusType.GREY_LIGHT
	},
	[CustomerStates.ACTIVE]: {
		color: ColorStatusType.WHITE,
		background: ColorStatusType.GREEN_LIGHT
	},
	[CustomerStates.PENDING_DISCONNECT]: {
		color: ColorStatusType.WHITE,
		background: ColorStatusType.RED_LIGHT
	},
	[CustomerStates.DISCONNECTED]: {
		color: ColorStatusType.WHITE,
		background: ColorStatusType.RED_LIGHT
	},
	[CustomerStates.CLOSED]: {
		color: ColorStatusType.WHITE,
		background: ColorStatusType.RED_LIGHT
	}
};

export const CustomerDocumentStateConfig: Record<CustomerDocumentStates, ChipStyle> = {
	[CustomerDocumentStates.VALIDATED]: {
		color: ColorStatusType.WHITE,
		background: ColorStatusType.GREEN_LIGHT
	}
};

enum AccountState {
	NEW = "New",
	PENDING_ACTIVE = "PendingActive",
	ACTIVE = "Active",
	PENDING_DISCONNECT = "PendingDisconnect",
	DISCONNECTED = "Disconnected",
	CLOSED = "Closed"
}

export interface CustomerDocumentDto {
	id: string;
	fileName: string;
	state: string;
	contentType: string;
	type: string;
	comment?: string;
	createdAt: string;
}

type CreateCustomerDocumentDtoBase = Pick<CustomerDocumentDto, "fileName" | "type" | "comment">;

export interface CreateCustomerDocumentDto extends CreateCustomerDocumentDtoBase {
	file: File;
}

export type UpdateCustomerDocumentDto = Pick<CustomerDocumentDto, "type" | "comment">;
